import React, { useState } from "react";
import { MsgError } from "../components/Shared";
import { useNavigate, useParams } from "react-router";

import api from "../utils/api.utils.js";
import { Link } from "react-router-dom";

import { Modal } from "react-bootstrap";

export const AddForm = ({ setMessage }) => {
  const [error, setError] = useState("");
  const [type, setType] = useState(true);

  const [anonimo, setAnonimo] = useState(false);

  const { category } = useParams();

  const navigate = useNavigate();

  //INPUTS
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");

  const [involved, setInvolved] = useState("");
  const [witness, setWitness] = useState("");
  const [talkedAbout, setTalkedAbout] = useState("");
  const [details, setDetails] = useState("");
  /*const [previousComplaint, setPreviousComplaint] = useState("");*/
  const [agreement, setAgreement] = useState(false);

  //HANDLE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let chars =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJLMNOPQRSTUVWXYZ!$%^&";
      let passwordLength = 10;
      let password = "";

      for (let i = 0; i < passwordLength; i++) {
        let randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber + 1);
      }

      const insert = await api.addComplaint(
        {
          name,
          role,
          email,
          telephone,
          category,
          involved,
          witness,
          talkedAbout,
          details,
          /*previousComplaint,*/
          password,
          agreement,
        },
        category
      );
      let anoDen = insert.updatedAt.slice(0, 4);
      let sucessMsg = `
      <p><b>Sua denúncia foi enviada com sucesso!</b></p> 
      <span>Acompanhe sua solicitação pelo:</span>
      <span>Protocolo: <b>${anoDen}DEN${insert.protocolo_id}</b></span>
      <span>Senha: <b>${password}</b></span>
      `;
      if (insert) {
        setMessage(sucessMsg);
        navigate("/");
      }
    } catch (error) {
      showMessage(error);
    }
  };

  const showMessage = (error) => {
    setError(error);
    setTimeout(() => {
      setError("");
    }, 6000);
  };
  const showID = () => {
    setType(true);
    setAnonimo(false);
  };
  const closeID = () => {
    setType(false);
    setName("");
    setAnonimo(true);
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="form-den">
      <section className="container mb-5 pb-5">
        <p className="p">Realizar Denúncia - Identificação</p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            Deseja se identificar?{"   "}
            {anonimo === false ? (
              <div onClick={closeID} className="btn btn-danger">
                Não
              </div>
            ) : (
              <div onClick={showID} className="btn btn-primary">
                Sim
              </div>
            )}
          </div>
          {type ? (
            <>
              <div className="mb-3">
                <input
                  className="form-control"
                  type="text"
                  name="nome"
                  id="nome"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  placeholder="Nome completo"
                />
              </div>
              <div className="mb-3">
                <input
                  className="form-control"
                  type="text"
                  name="funcao"
                  id="funcao"
                  value={role}
                  onChange={(e) => {
                    setRole(e.target.value);
                  }}
                  placeholder="Função (caso seja colaborador)"
                />
              </div>
              <div className="mb-3">
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  placeholder="Melhor e-mail"
                />
              </div>
              <div className="mb-3">
                <input
                  className="form-control"
                  type="phone"
                  name="telefone"
                  id="telefone"
                  value={telephone}
                  onChange={(e) => {
                    setTelephone(e.target.value);
                  }}
                  placeholder="Telefone de contato"
                />
              </div>
            </>
          ) : null}
          <hr />
          <p className="p">Detalhamento da denúncia</p>
          <p>
            Nos campos abaixo você deve descrever a situação de descumprimento
            com nossos princípios e valores, outros documentos internos ou leis
            que deseja relatar.
          </p>
          <p>
            É importante que a descrição seja suficientemente completa de forma
            a permitir que a empresa tenha os dados necessários para apurar os
            fatos:
          </p>
          <ul>
            <li>O quê (descrição da situação)</li>
            <li>Quem (nome das pessoas envolvidas, inclusive testemunhas)</li>
            <li>
              Quando (data em que aconteceu, acontece ou acontecerá a situação)
            </li>
            <li>Onde (local do relato)</li>
            <li>Por que (a causa ou motivo)</li>
            <li>Quanto (se for possível medir)</li>
            <li>Provas (se elas existem e onde podem ser encontradas)</li>
          </ul>
          <p>
            Para acompanhar o andamento da sua denúncia, após finalizar seu
            registro você receberá um número de protocolo. Posteriormente,
            utilize a opção{" "}
            <Link to="/track-complaint/" style={{ color: "blue !important" }}>
              <i> “Acompanhar Denúncia”</i>
            </Link>{" "}
            e entre com esse número. Lá você encontrará informação sobre o
            estágio de investigação do relato (não iniciado, em andamento ou
            finalizado).
          </p>
          <p>Agradecemos sua iniciativa e confiança.</p>

          <div className="mb-3">
            <label htmlFor="envolvidos">
              Quem são os envolvidos?{" "}
              <span style={{ fontSize: "0.7rem" }}>
                Nome, sobrenome, cargo, departamento, etc.
              </span>
            </label>
            <textarea
              className="form-control"
              name="envolvidos"
              id="envolvidos"
              cols="30"
              rows="5"
              value={involved}
              onChange={(e) => {
                setInvolved(e.target.value);
              }}
            ></textarea>
          </div>
          <div className="mb-3">
            <label htmlFor="witness">
              Quem presenciou o ocorrido?{" "}
              <span style={{ fontSize: "0.7rem" }}>
                Dados de testemunhas: Nome, sobrenome, cargo, departamento,
                telefone, e-mail, etc.
              </span>
            </label>
            <textarea
              className="form-control"
              name="witness"
              id="witness"
              cols="30"
              rows="5"
              value={witness}
              onChange={(e) => {
                setWitness(e.target.value);
              }}
            ></textarea>
          </div>
          <div className="mb-3">
            <label htmlFor="talkedAbout">
              Você já conversou com alguém sobre essas informações? Se sim, com
              quem?
            </label>
            <textarea
              className="form-control"
              name="talkedAbout"
              id="talkedAbout"
              cols="30"
              rows="5"
              value={talkedAbout}
              onChange={(e) => {
                setTalkedAbout(e.target.value);
              }}
            ></textarea>
          </div>
          <div className="mb-3">
            <label htmlFor="details">
              Detalhamento da Denúncia (descreva em detalhe a situação,
              informando datas, locais, quantias e possíveis fatos que comprovem
              o relato)
            </label>
            <textarea
              className="form-control"
              name="details"
              id="details"
              cols="30"
              rows="5"
              value={details}
              onChange={(e) => {
                setDetails(e.target.value);
              }}
            ></textarea>
          </div>
          {/*
          <div className="mb-3">
            <label htmlFor="previousComplaint">
              Se esta denúncia está relacionada a uma denúncia anterior, informe
              o número do protocolo da denúncia anterior:
            </label>
            <input
              className="form-control"
              type="number"
              name="previousComplaint"
              id="previousComplaint"
              value={previousComplaint}
              onChange={(e) => {
                setPreviousComplaint(e.target.value);
              }}
            />
          </div>
              */}
          <div className="mb-3">
            <p>
              Todas as informações aqui registradas serão recebidas pelo comitê
              de denúncias, assegurando sigilo absoluto e o tratamento adequado
              de cada situação pelo Canal de Denúncias do 1RIGO.
            </p>
            <p>
              A captação dessas informações tem por finalidade a apuração de
              possíveis condutas que violem as nossas políticas, as normas
              vigentes ou a legislação aplicável.
            </p>
            <p>
              <Link className="" variant="primary" onClick={handleShow}>
                Clique aqui{" "}
              </Link>
              para ler o Termo com o detalhamento do tratamento de seus dados
              conforme a Lei Geral de Proteção de Dados.
            </p>
          </div>
          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              value={agreement}
              onChange={(e) => {
                setAgreement(!agreement);
              }}
              id="flexCheckDefault"
            />
            <label className="form-check-label" htmlFor="flexCheckDefault">
              <strong>
                Estou ciente que todos os dados relatados ou disponibilizados
                serão tratados nos termos descritos acima.
              </strong>
            </label>
          </div>
          <div className="mb-5 button-denuncia-mobile">
            {error !== "" && <MsgError id="erroID">{error}</MsgError>}
            <button type="submit" className="btn btn-primary">
              Enviar denúncia
            </button>
          </div>
        </form>
        {/* Modal */}
        <Modal
          style={{ marginTop: "2%" }}
          show={show}
          onHide={handleClose}
          size="lg"
        >
          <Modal.Header closeButton>
            <h6>Termo de Consentimento e Aviso de Privacidade</h6>
          </Modal.Header>
          <Modal.Body>
            <p className="d-flex flex-column modal-termo">
              <h5 style={{ textAlign: "center" }}>
                CARTÓRIO DE REGISTRO DE IMÓVEIS DA 1ª CIRCUNSCRIÇÃO DE GOIÂNIA
              </h5>
              <br />
              <h6 style={{ textAlign: "center" }}>
                TERMO DE CONSENTIMENTO E AVISO DE PRIVACIDADE CANAL DE DENÚNCIAS
              </h6>
              <br />
              <small>
                <span>
                  ENCARREGADO(A): <strong> Letícia Maria dos Santos</strong>
                </span>
                <br />
                <span>Versão nº 001– Data da emissão: 10/04/2023</span>
              </small>
              <br />

              <p>
                <br />
              </p>
              <p>
                Ao prosseguir com o preenchimento do formulário, o{" "}
                <b>DENUNCIANTE </b>consente e concorda que o 1ºRIGO, através de
                seu Oficial Igor França Guedes, tome decisões referentes ao
                tratamento de seus dados pessoais, bem como realize o tratamento
                destes, envolvendo operações como a coleta, utilização, acesso,
                armazenamento e eliminação das informações.
              </p>

              <p>
                Este termo está vinculado ao Aviso de Privacidade Geral, que se
                encontra disponível para acesso no website do 1RIGO, bem como ao
                aviso de privacidade para DENUNCIANTE, abaixo descrito.
              </p>

              <ol id="l1">
                <li data-list-text="1.">
                  <h6>DOS DADOS PESSOAIS</h6>

                  <p>
                    Os dados pessoais coletados do <b>DENUNCIANTE </b>são:
                  </p>

                  <ol id="l2">
                    <li data-list-text="1.">
                      <p>
                        <span class="s1">nome completo;</span>
                      </p>
                    </li>
                    <li data-list-text="2.">
                      <p>
                        <span class="s1">endereço residencial;</span>
                      </p>
                    </li>
                    <li data-list-text="3.">
                      <p>
                        <span class="s1">
                          número de telefone e contato WhatsApp;
                        </span>
                      </p>
                    </li>
                    <li data-list-text="4.">
                      <p>
                        <span class="s1">endereço de e-mail pessoal;</span>
                      </p>
                    </li>
                    <li data-list-text="5.">
                      <p>
                        <span class="s1">
                          documentos de identificação como RG, CPF e CNH.
                        </span>
                      </p>
                    </li>
                  </ol>

                  <p>
                    O tratamento dos dados pessoais poderá ser realizado para o
                    recebimento e processamento de reclamações e/ou denúncias;
                    para manter os denunciantes informados sobre o andamento das
                    mesmas; bem como para viabilizar a averiguação dos dados e
                    informações relatadas, por meio de procedimento próprio, com
                    a finalidade de reunir evidências para a apuração de
                    eventuais condutas ilegais e imorais envolvendo esta
                    Serventia Extrajudicial e seus prepostos.
                  </p>

                  <h6>
                    <span class="p">
                      Poderá ainda o DENUNCIANTE se valer da anonimização de
                      seus dados , caso em que somente serão coletados e
                      tratados dados fornecidos automaticamente, quando da
                      navegação do DENUNCIANTE na nossa plataforma. Para tal
                      coleta, o 1RIGO fará uso de algumas tecnologias padrões, a
                      exemplo de cookies, que são utilizados com o propósito de
                      melhorar a experiência de navegação do Usuário.
                    </span>
                  </h6>

                  <p>
                    Importante esclarecer que o 1RIGO não coleta ou identifica
                    individualmente essas informações para fins de análise, e
                    também não colhe dados após você fazer login no referido
                    ‘canal’. Mas apenas analisa esses dados de forma
                    estatística, nunca individual, e sempre com o objetivo de
                    entender melhor os interesses e necessidades dos
                    utilizadores de seus canais.
                  </p>
                </li>
                <li data-list-text="2.">
                  <h6>DO COMPARTILHAMENTO E SEGURANÇA DOS DADOS</h6>

                  <p>
                    O <b>DENUNCIANTE, </b>desde já, autoriza o compartilhamento
                    de seus dados pessoais com área interna de gestão de pessoas
                    do Cartório e Comitê instalado especificamente para apuração
                    de denúncias, ainda, com empresas terceiras que fornecem
                    licença de software para armazenamento e gestão de dados.
                  </p>

                  <p>
                    O <b>1RIGO </b>responsabiliza-se pela manutenção de medidas
                    de segurança, técnicas e administrativas aptas a proteger os
                    dados pessoais de acessos não autorizados e de situações
                    acidentais ou ilícitas de destruição, perda, alteração,
                    comunicação ou qualquer forma de tratamento inadequado ou
                    ilícito.
                  </p>

                  <p>
                    Em conformidade ao artigo 48 da Lei nº 13.709, o{" "}
                    <b>1RIGO </b>comunicará ao <b>DENUNCIANTE </b>e à Autoridade
                    Nacional de Proteção de Dados – ANPD a ocorrência de
                    incidente de segurança que possa acarretar risco ou dano
                    relevante ao mesmo.
                  </p>
                </li>
                <li data-list-text="3.">
                  <h6>DO TÉRMINO DO TRATAMENTO DOS DADOS</h6>

                  <p>
                    O <b>1RIGO </b>poderá manter e tratar os dados pessoais do{" "}
                    <b>DENUNCIANTE </b>durante todo o período em que os mesmos
                    forem pertinentes para a apuração e aplicação de penalidades
                    em decorrência dos fatos denunciados. Ainda, para
                    cumprimento de obrigação legal.
                  </p>

                  <p>
                    O <b>DENUNCIANTE </b>poderá solicitar ao <b>1RIGO, </b>a
                    qualquer momento, que sejam eliminados seus dados pessoais
                    por meio do e-mail{" "}
                    <Link
                      to="mailto:privacidade@1rigo.com.br"
                      class="a"
                      target="_blank"
                      rel="noreferrer"
                    >
                      privacidade@1rigo.com.br,
                    </Link>{" "}
                    sendo que sua solicitação será considerada de acordo com as
                    leis aplicáveis.
                  </p>
                </li>
                <li data-list-text="4.">
                  <h6>DOS DIREITOS DO CANDIDATO</h6>

                  <p>
                    O <b>DENUNCIANTE </b>tem direito a obter do <b>1RIGO</b>, em
                    relação aos dados por ele tratados, a qualquer momento e
                    mediante requisição:
                  </p>

                  <ul id="l3">
                    <li data-list-text="">
                      <p>confirmação da existência de tratamento;</p>
                    </li>
                    <li data-list-text="">
                      <p>acesso aos dados;</p>
                    </li>
                    <li data-list-text="">
                      <p>
                        correção de dados incompletos, inexatos ou
                        desatualizados;
                      </p>
                    </li>
                    <li data-list-text="">
                      <p>
                        anonimização, bloqueio ou eliminação de dados
                        desnecessários, excessivos ou tratados em
                        desconformidade com o disposto na Lei nº 13.709;
                      </p>
                    </li>
                    <li data-list-text="">
                      <p>
                        eliminação dos dados pessoais tratados com o
                        consentimento do <b>DENUNCIANTE</b>, exceto nas
                        hipóteses previstas no artigo 16 da Lei nº 13.709;
                      </p>
                    </li>
                    <li data-list-text="">
                      <p>
                        revogação do consentimento, nos termos do § 5º do artigo
                        8º da Lei nº 13.709.
                      </p>
                    </li>
                  </ul>
                </li>
                <li data-list-text="5.">
                  <h6>DIREITO DE REVOGAÇÃO DO CONSENTIMENTO</h6>

                  <p>
                    Conforme disposto acima, este consentimento poderá ser
                    revogado pelo <b>DENUNCIANTE</b>, a qualquer momento,
                    mediante solicitação ao <b>1RIGO. </b>Inobstante, a
                    revogação do consentimento poderá ensejar a inviabilidade da
                    apuração e punição dos fatos relacionados na denúncia.
                  </p>

                  <p>Ciente e de acordo.</p>
                </li>
                <li data-list-text="6.">
                  <h6>HISTÓRICO DE VERSÕES</h6>
                </li>
              </ol>

              <table cellSpacing="0">
                <tr>
                  <td bgcolor="#A4A4A4">
                    <p class="s2">DATA</p>
                  </td>
                  <td bgcolor="#A4A4A4">
                    <p class="s2">VERSÃO</p>
                  </td>
                  <td bgcolor="#A4A4A4">
                    <p class="s2">DESCRIÇÃO DAS ALTERAÇÕES</p>
                  </td>
                  <td bgcolor="#A4A4A4">
                    <p class="s2">RESPONSÁVEL</p>
                  </td>
                </tr>
                <tr>
                  <td bgcolor="#ECECEC">
                    <p class="s3">Abr/2023</p>
                  </td>
                  <td bgcolor="#ECECEC">
                    <p class="s3">001</p>
                  </td>
                  <td bgcolor="#ECECEC">
                    <p class="s3">
                      Termo de Consentimento e Aviso de Privacidade – Canal de
                      Denúncias do Cartório de Registro de Imóveis da 1ª
                      Circunscrição de Goiânia-GO
                    </p>
                  </td>
                  <td bgcolor="#ECECEC">
                    <p class="s3">
                      Elaboração: Consultoria externa (Ana Clara Duarte e Carlos
                      Eduardo Brito)
                    </p>
                    <p class="s3">
                      Revisão e aprovação: Letícia Maria dos Santos
                    </p>
                  </td>
                </tr>
              </table>
            </p>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </section>
    </div>
  );
};
